import React from 'react';
import { Alert, AlertDescription, AlertTitle, Box, Button, HStack, Icon, Spinner, Text } from '@chakra-ui/react';
import { LuShieldOff } from 'react-icons/lu';
import { useServiceStatus } from '../query/useServiceStatus';

export default function ServiceRecoveryBanner(props) {
  const statusQuery = useServiceStatus();

  if (statusQuery.isLoading || statusQuery.isError) {
    return null;
  }

  const automationDisabled = statusQuery.data?.automationEnabled === false;
  if (!automationDisabled) return null;

  const message = statusQuery.data?.message || 'Ekkos is paused while we recover. Scheduling and notifications are temporarily off.';

  return (
    <Alert
      status="warning"
      variant="solid"
      bgGradient="linear(to-r, orange.400, red.400)"
      color="white"
      borderRadius="lg"
      alignItems="center"
      {...props}
    >
      <HStack align="center" spacing={3} flex="1">
        <Icon as={LuShieldOff} boxSize={6} aria-hidden />
        <Box flex="1">
          <AlertTitle fontWeight="bold">Recovery mode active</AlertTitle>
          <AlertDescription>
            <Text fontSize="sm">
              {message} Scheduling new reminders and edits are disabled, and outbound notifications are paused.
            </Text>
          </AlertDescription>
        </Box>
      </HStack>
      <Button
        size="sm"
        variant="outline"
        colorScheme="whiteAlpha"
        ml={{ base: 2, md: 4 }}
        onClick={() => statusQuery.refetch()}
        isLoading={statusQuery.isFetching}
        leftIcon={!statusQuery.isFetching ? <Icon as={LuShieldOff} /> : undefined}
      >
        {statusQuery.isFetching ? <Spinner size="sm" color="white" /> : 'Refresh'}
      </Button>
    </Alert>
  );
}
